import BaseModelAPI from '../BaseModelAPI';

export default class ProductionControlTimeDetail extends BaseModelAPI {
	static entity = 'productioncontroltimedetail';
	static entityName = 'productioncontroltimedetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.standarTimeIdId = '';
			this.standarTimeId = {};
			this.productionControlTimeId = '';
			this.productionControlTime = {};
			this.standarTimeValue = '';
			this.standarTimeCategory = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}